import { Component } from '@angular/core';

@Component({
  selector: 'grid-apps-auth-callback',
  standalone: true,
  imports: [],
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
})
export class CallbackComponent {}
